import { CART_CONSTANTS, CONFIG_CONSTANTS, LANG_CONSTANTS, STORE_CONSTANTS } from '../actionTypes'
import { HELPER, IMAGE_SRC, CONSTANTS } from '../../utils'
import { configActions } from '../actions'

const merchant = {
	store_name: 'bSecure pvt ltd',
	logo: IMAGE_SRC.BSECURE_DEFAULT_LOGO,
	favicon: IMAGE_SRC.BSECURE_FAVICON,
	currency_code: 'PKR',
	store_slug: '',
	gtm_id: process.env.REACT_APP_DEFAULT_GTM_ID,
	theme_color: process.env.REACT_APP_DEFAULT_APP_THEME_COLOR,
	payment_icon: '',
	segment_id: '',
}

const default_catalog_journey_settings = {
	user_journey: '',
	product_items: [],
	catalog_cart_items: [],
}

const merchant_seo_settings = {
	page_title: process.env.REACT_APP_EN_PAGE_TITLE,
	meta_title: process.env.REACT_APP_META_TITLE,
	meta_description: process.env.REACT_APP_META_DESCRIPTION,
	open_graph_title: process.env.REACT_APP_OPEN_GRAPH_TITLE,
	open_graph_image: process.env.REACT_APP_OPEN_GRAPH_IMAGE,
	open_graph_description: process.env.REACT_APP_OPEN_GRAPH_DESCRIPTION,
}

const default_catalog_without_product_journey = {
	set_catalog_without_product: false,
	catalog_without_product_item: null,
}

const initState = {
	browseStores: false,
	config_info_loading: false,
	config_info_loaded: false,

	config_load_count: 0,

	catalog_info_loading: false,
	disableCatalogInfoLoading: false,

	last_updated: {
		prev: 0,
		new: 0,
	},

	merchant: merchant,
	app_seo: merchant_seo_settings,

	catalog_journey_settings: default_catalog_journey_settings,
	checkout_language: {
		old: null,
		new: null,
		// new: CONSTANTS.IS_ENGLISH,
	},

	merchant_banner_settings: {
		banner: IMAGE_SRC.CAT_BANNER_IMG,
		default: IMAGE_SRC.CAT_BANNER_IMG,
	},

	default_username: 'Guest',
	show_back_btn: false,
	// show page in catalog without product journey 
	catalog_without_product_journey: default_catalog_without_product_journey,
	custom_catalog: false,
	catalogue_key: '',
}

let merchant_info,
	default_category_banner,
	banner,
	response,
	catalog_product_id,
	catalog_cart_items,
	additional_details

const configReducer = (state = initState, action) => {
	switch (action.type) {
		case 'RESET':
			return initState
		case STORE_CONSTANTS.ACCESS_NEW_STORE:
			response = action?.response
			return {
				// ...state,
				...initState,
				custom_catalog: true,
				browseStores: true,
				catalogue_key: action?.response?.catalogue_key,
			}
		case CONFIG_CONSTANTS.CUSTOM_CATALOG_DOMAIN_DEFAULT:
			return {
				...state,
				custom_catalog: true,
				catalogue_key: action?.response?.catalogue_key,
			}
		case CONFIG_CONSTANTS.SET_APP_SETTINGS_TO_DEFAULT:
			return initState
		case CART_CONSTANTS.UPDATE_CART_LOCALE_REQUEST:
			return {
				...state,
				catalog_journey_settings: {
					...state?.catalog_journey_settings,
					product_items: [],
					catalog_cart_items: [],
				},
			}
		case CONFIG_CONSTANTS.STORE_CONFIGURATION_REQUEST:
			return {
				...state,
				catalog_access_rejected: false,
				config_info_loading: true,
				catalogue_key: action?.catalogue_key,
				config_info_loaded: false,
			}
		case CONFIG_CONSTANTS.STORE_CONFIGURATION_SUCCESS:
			response = action?.response
			merchant_info = {
				currency_code: response?.data?.metadata?.currency_code,
				logo: response?.data?.metadata?.desktop_logo_url,
				favicon: response?.data?.metadata?.fav_icon_url,
				checkout_language: response?.data?.metadata?.default_lang,
				store_name: response?.data?.metadata?.store_name,
				store_slug: response?.data?.metadata?.store_slug,
				gtm_id: response?.data?.metadata?.gtm_id,
				segment_id: response?.data?.metadata?.segment_id,
				theme_color: response?.data?.metadata?.theme_color,
				payment_icon: response?.data?.metadata?.payment_icon,
				under_construction: response?.data?.metadata?.under_construction,
				is_all_product_enable: response?.data?.metadata?.is_all_product_enable,
			}
			catalog_product_id = !HELPER.isEmpty(response?.product_id)
				? HELPER.addObjectToCollection(
						response?.product_id,
						state?.catalog_journey_settings?.product_items
				  )
				: default_catalog_journey_settings.product_items
			return {
				...state,
				custom_catalog: false,
				config_load_count: parseInt(state.config_load_count) + 1,
				catalog_journey_settings: {
					...state?.catalog_journey_settings,
					// user_journey: state?.catalog_journey_settings?.user_journey,
					product_items: catalog_product_id,
					// catalog_cart_items: state?.catalog_journey_settings?.catalog_cart_items
				},
				config_info_loading: false,
				config_info_loaded: true,
				disableCatalogInfoLoading: false,
				last_updated: {
					...state?.last_updated,
					prev: state?.last_updated?.new,
					new: response?.data?.last_updated,
				},
				merchant: merchant_info,
				app_seo: response?.data?.metadata?.seo,
			}
		case CONFIG_CONSTANTS.UPDATED_STORE_CONFIGURATION_SUCCESS:
			response = action?.response
			catalog_cart_items = !HELPER.isEmpty(response?.cart_items) ? response?.cart_items : []
			catalog_product_id = !HELPER.isEmpty(response?.product_id)
				? HELPER.addObjectToCollection(
						response?.product_id,
						state?.catalog_journey_settings?.product_items
				  )
				: []
			let catalog_inventory_check = response?.product_list
			return {
				...state,
				config_load_count: parseInt(state.config_load_count) + 1,
				catalog_journey_settings: {
					...state?.catalog_journey_settings,
					product_items: catalog_product_id,
					catalog_cart_items,
				},
				show_back_btn:
					catalog_cart_items?.user_journey !== CONSTANTS.PRODUCT_JOURNEYS.DIRECT_CHECKOUT
						? true
						: false,
				config_info_loading: false,
				config_info_loaded: false,
				disableCatalogInfoLoading:
					state?.checkout_language.old === state?.checkout_language.new &&
					!HELPER.isEmpty(catalog_inventory_check)
						? true
						: false,
			}
		case CONFIG_CONSTANTS.STORE_CONFIGURATION_FAILURE:
			return {
				...state,
				config_info_loading: true,
				catalog_access_rejected: true,
			}
		case CONFIG_CONSTANTS.STORE_CATALOG_INFO_REQUEST:
			return {
				...state,
				catalog_info_loading: true,
				config_info_loaded: false,
			}
		case CONFIG_CONSTANTS.STORE_CATALOG_INFO_SUCCESS:
			response = action?.response?.data
			banner = response?.catalog_settings?.banners
			catalog_cart_items = !HELPER.isEmpty(action?.response?.cart_items)
				? action?.response?.cart_items
				: []
			default_category_banner =
				response?.categories_with_products?.default_category?.category?.banner
			merchant_info = {
				currency_code: response?.metadata?.currency_code,
				logo: response?.metadata?.desktop_logo_url,
				favicon: response?.metadata?.fav_icon_url,
				checkout_language: response?.metadata?.default_lang,
				store_name: response?.metadata?.store_name,
				store_slug: response?.metadata?.store_slug,
				gtm_id: response?.metadata?.gtm_id,
				segment_id: response?.metadata?.segment_id,
				theme_color: response?.metadata?.theme_color,
				payment_icon: response?.metadata?.payment_icon,
				banner_text: response?.metadata?.banner_text,
				under_construction: response?.metadata?.under_construction,
				is_all_product_enable: response?.metadata?.is_all_product_enable,
			}
			//for privacy_policy and about us
			additional_details = {
				about_us: response?.additional_details?.about_us,
				pages: response?.additional_details?.pages,
				privacy_policy: response?.additional_details?.privacy_policy,
			}
			return {
				...state,
				additional_details,
				catalog_info_loading: false,
				merchant: merchant_info,
				default_banner: banner,
				merchant_banner_settings: {
					banner: HELPER.isEmpty(default_category_banner) ? banner : default_category_banner,
					default: banner,
				},
				app_seo: response?.metadata?.seo,
				show_back_btn:
					catalog_cart_items?.user_journey !== CONSTANTS.PRODUCT_JOURNEYS.DIRECT_CHECKOUT
						? true
						: false,
				catalog_journey_settings: {
					...state?.catalog_journey_settings,
					user_journey: response?.catalog_settings?.user_journey,
					product_items: !HELPER.isEmpty(catalog_cart_items)
						? state?.catalog_journey_settings?.product_items
						: [],
					catalog_cart_items,
				},
			}
		case CONFIG_CONSTANTS.STORE_CATALOG_INFO_FAILURE:
			return {
				...state,
				catalog_info_loading: false,
			}
		case CART_CONSTANTS.CHANGE_CATEGORY_SUCCESS:
			banner = action?.response?.category?.banner
			return {
				...state,
				merchant_banner_settings: {
					banner: !HELPER.isEmpty(banner) ? banner : state?.merchant_banner_settings.default,
					default: state?.merchant_banner_settings.default,
				},
			}
		case LANG_CONSTANTS.CHANGE_LANGUAGE_LOCALE:
			merchant_info = {
				currency_code: state?.merchant?.currency_code,
				logo: state?.merchant?.logo,
				favicon: state?.merchant?.favicon,
				checkout_language: action?.locale,
				store_name: state?.merchant?.store_name,
				store_slug: state?.merchant?.store_slug,
				gtm_id: state?.merchant?.gtm_id,
				segment_id: state?.merchant?.segment_id,
				theme_color: state?.merchant?.theme_color,
				payment_icon: state?.merchant?.payment_icon,
				under_construction: state?.merchant?.under_construction,
			}
			return {
				...state,
				config_info_loaded: !state?.config_info_loaded ? true : state?.config_info_loaded,
				disableCatalogInfoLoading: state?.disableCatalogInfoLoading
					? state?.disableCatalogInfoLoading
					: false,
				merchant: merchant_info,
				checkout_language: {
					old: state?.checkout_language?.new,
					new: action?.locale,
				},
				// default_username: action?.locale === CONSTANTS.IS_ENGLISH ? "Guest" : "گیسٹ",
			}
		case LANG_CONSTANTS.UPDATE_LANGUAGE_LOCALE:
			return {
				...state,
				catalog_journey_settings: {
					...state?.catalog_journey_settings,
					product_items: [],
					catalog_cart_items: [],
				},
				disableCatalogInfoLoading: false,
			}
		case CART_CONSTANTS.REMOVE_CART_ITEMS_FROM_CATALOG_JOURNEY_SETTINGS:
			return {
				...state,
				catalog_journey_settings: {
					...state?.catalog_journey_settings,
					product_items: [],
					catalog_cart_items: [],
				},
			}
		case CART_CONSTANTS.ADD_ITEM_TO_CART:
			let cart_item = action?.cart_item
			return {
				...state,
				catalog_journey_settings: {
					...state?.catalog_journey_settings,
					user_journey: cart_item?.user_journey,
				},
			}
		case configActions.EMPTY_CATALOG_CART_ITEMS:
			return {
				...state,
				catalog_journey_settings: {
					...state?.catalog_journey_settings,
					product_items: [],
				},
			}
		case CONFIG_CONSTANTS.SET_CATALOG_WITHOUT_PRODUCT_JOURNEY:
			return {
				...state,
				catalog_without_product_journey: {
					set_catalog_without_product: action?.response?.set_catalog_without_product,
					catalog_without_product_item: action?.response?.catalog_without_product_item,
				},
			}
		case CONFIG_CONSTANTS.EMPTY_CATALOG_WITHOUT_PRODUCT_JOURNEY:
			return {
				...state,
				catalog_without_product_journey: default_catalog_without_product_journey,
			}
		case STORE_CONSTANTS.SHOP_LISTING_SUCCESS:
			response = action?.response
			merchant_info = {
				logo: response?.metadata?.desktop_logo_url,
				favicon: response?.metadata?.fav_icon_url,
				checkout_language: response?.metadata?.default_lang,
				store_name: response?.metadata?.app_name,
				gtm_id: response?.metadata?.gtm_id,
				segment_id: response?.metadata?.segment_id,
				theme_color: response?.metadata?.theme_color,
			}
			return {
				...state,
				merchant: merchant_info,
				app_seo: response?.metadata?.seo,
			}
		default:
			return state
	}
}
export default configReducer
